import { __assign, __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import numeral from 'numeral';
import { withTranslation } from 'react-i18next';
import onClickOutside from 'react-onclickoutside';
import { URLS, Url } from '@wix/da-url';
import StandardMenu from '../../../Dropdown/Preset/StandardMenu';
import UserAvatar from '../../../User/Avatar';
import UserAvatarPlaceholder from '../../../User/AvatarPlaceholder';
import UserLink from '../../../User/Link';
import CoreIconSmall from '../../../Icons/CoreIconSmall';
import MatureToggle from '../../../MatureToggle';
import LogoutItem from '../../_partials/LogoutItem';
import { BiEventType, BiLink, BiSpan } from '../../../biLogger';
import Flex from '../../../Flex';
import Dino from '../../../Icons/Dino';
import { withFeatureFlags } from '../../../redux/flags';
import VerificationReminder from '../../_partials/VerificationReminder';
import ThemeSwitchGreen from '../../../Icons/ThemeSwitchGreen';
import ThemeSwitchLight from '../../../Icons/ThemeSwitchLight';
import ThemeSwitchDark from '../../../Icons/ThemeSwitchDark';
import Button from '../../../Button';
import Pencil from '../../../Icons/Pencil';
import Eye from '../../../Icons/Eye';
import { ThemeOverride } from '../../../Context';
import { ThemeOptions, ThemeSkin } from '../../../publicSession';
import PlainButtonOrLink from '../../../Button/PlainButtonOrLink';
import SiteHeaderStyles from '../SiteHeader.scss';
import s from './UserDropdownMenu.scss';
var UserDropdownMenu = /** @class */ (function (_super) {
    __extends(UserDropdownMenu, _super);
    function UserDropdownMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            touchIsOpen: false,
        };
        _this.logoutItemRef = React.createRef();
        _this.getBuyCore = function () {
            var _a = _this.props, t = _a.t, hasCoreMembership = _a.hasCoreMembership;
            return {
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", null, hasCoreMembership
                        ? t('siteHeader.extendCore')
                        : t('siteHeader.buyCoreMembership')),
                    React.createElement("span", null,
                        React.createElement(CoreIconSmall, null)))),
                link: URLS.CORE_MEMBERSHIP,
                componentClass: BiLink,
                componentProps: {
                    biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        link_url: URLS.CORE_MEMBERSHIP,
                        menu_item: 'core_membership',
                        menu_name: 'profile',
                    },
                },
            };
        };
        _this.getVersionSwitcher = function () {
            var t = _this.props.t;
            return {
                label: (React.createElement("div", { className: classnames(s['two-side-label']) },
                    React.createElement("span", null, t('siteHeader.userMenu.switchVersion')),
                    React.createElement(Dino, null))),
                className: s['version-switcher'],
                onClick: _this.props.switchVersion,
            };
        };
        _this.getMatureToggleItem = function () {
            var _a = _this.props, t = _a.t, _b = _a.matureContent, matureContent = _b === void 0 ? false : _b, toggleMature = _a.toggleMature;
            return {
                label: (React.createElement("div", { className: classnames(s['mature-label'], s['two-side-label']) },
                    React.createElement("span", { onClick: function () { return toggleMature(matureContent); } }, t('siteHeader.matureContent')),
                    React.createElement(MatureToggle, { className: classnames(s['mature-toggle'], matureContent && s['checked']), forcedLightTheme: true, checked: matureContent, onChange: toggleMature }))),
                componentClass: BiSpan,
                componentProps: {
                    biData: {
                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                        menu_item: 'toggle_mature',
                        menu_name: 'profile',
                        toggle_value: !matureContent ? 'mature_on' : 'mature_off',
                    },
                },
            };
        };
        _this.getWixPortfolio = function () {
            var _a = _this.props, t = _a.t, hasWixPortfolio = _a.hasWixPortfolio, pushWixPortfolioModal = _a.pushWixPortfolioModal, isLegacyHeader = _a.isLegacyHeader;
            var createPortfolio = pushWixPortfolioModal;
            if (isLegacyHeader) {
                var url_1 = Url.browseHomeLink() + "?submit_modal=portfolio";
                createPortfolio = function () {
                    window.location.assign(url_1);
                };
            }
            return {
                label: (React.createElement("div", { className: classnames(s['two-side-label'], s['portfolio-label']) },
                    React.createElement(PlainButtonOrLink, { className: s['portfolio-text'], onClick: hasWixPortfolio ? undefined : createPortfolio, href: hasWixPortfolio ? '/wixsite/edit' : undefined, target: "_blank", biData: {
                            evid: hasWixPortfolio
                                ? BiEventType.WIX_PORTFOLIO_PREVIEW_EDIT_CLICK
                                : BiEventType.WIX_PORTFOLIO_CREATE_CLICK,
                            sectionname: 'usermenu',
                            button_type: 'portfolio',
                        } },
                        t('siteHeader.userMenu.wixPortfolio.portfolio'),
                        React.createElement("span", { className: s['portfolio-beta'] }, "beta")),
                    React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT }, hasWixPortfolio ? (React.createElement(React.Fragment, null,
                        React.createElement(BiLink, { className: s['portfolio-button'], href: "/wixsite/view", target: "_blank", biData: {
                                evid: BiEventType.WIX_PORTFOLIO_PREVIEW_EDIT_CLICK,
                                sectionname: 'usermenu',
                                button_type: 'preview',
                            } },
                            React.createElement(Eye, { disableDefaultColors: true })),
                        React.createElement(BiLink, { className: s['portfolio-button'], href: "/wixsite/edit", target: "_blank", biData: {
                                evid: BiEventType.WIX_PORTFOLIO_PREVIEW_EDIT_CLICK,
                                sectionname: 'username',
                                button_type: 'edit',
                            } },
                            React.createElement(Pencil, { disableDefaultColors: true })))) : (React.createElement(Button, { view: "b3", onClick: createPortfolio, className: s['portfolio-create-button'], biData: {
                            evid: BiEventType.WIX_PORTFOLIO_CREATE_CLICK,
                            sectionname: 'usermenu',
                        } }, t('siteHeader.userMenu.wixPortfolio.create')))))),
            };
        };
        _this.getThemeSwitcherIfApplicable = function () {
            var _a = _this.props, t = _a.t, disableThemeSwitcher = _a.disableThemeSwitcher, theme = _a.theme, themeSkin = _a.themeSkin, setThemeSkin = _a.setThemeSkin, setTheme = _a.setTheme;
            if (disableThemeSwitcher) {
                return null;
            }
            var baseBiData = {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                menu_item: 'toggle_theme',
                menu_name: 'profile',
            };
            return {
                className: s['non-clickable'],
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", { className: s['no-hover'] }, t('siteHeader.mode')),
                    React.createElement("span", { className: s['theme-toggles'] },
                        React.createElement(BiSpan, { title: t('siteHeader.userMenu.themeDark'), onClick: function () { return setTheme(ThemeOptions.DARK); }, className: classnames(s['theme-toggle-item'], theme === ThemeOptions.DARK && !themeSkin && s['active']), biData: __assign(__assign({}, baseBiData), { toggle_value: 'dark' }) },
                            React.createElement(ThemeSwitchDark, null)),
                        React.createElement(BiSpan, { title: t('siteHeader.userMenu.themeLight'), onClick: function () { return setTheme(ThemeOptions.LIGHT); }, className: classnames(s['theme-toggle-item'], theme === ThemeOptions.LIGHT && !themeSkin && s['active']), biData: __assign(__assign({}, baseBiData), { toggle_value: 'light' }) },
                            React.createElement(ThemeSwitchLight, null)),
                        React.createElement(BiSpan, { title: t('siteHeader.userMenu.themeGreen'), onClick: function () { return setThemeSkin(ThemeSkin.GREEN); }, className: classnames(s['theme-toggle-item'], themeSkin === ThemeSkin.GREEN && s['active']), biData: __assign(__assign({}, baseBiData), { toggle_value: 'green' }) },
                            React.createElement(ThemeSwitchGreen, null))))),
            };
        };
        _this.handleLogout = function () {
            _this.logoutItemRef &&
                _this.logoutItemRef.current &&
                _this.logoutItemRef.current.submit();
        };
        _this.handleTouch = function (e) {
            e.preventDefault();
            _this.setState({ touchIsOpen: true });
        };
        _this.handleClickOutside = function () {
            if (!_this.state.touchIsOpen) {
                return;
            }
            _this.setState({ touchIsOpen: false });
        };
        _this.handleClickUserMenuOpen = function () {
            _this.setState({
                touchIsOpen: !_this.state.touchIsOpen,
            });
        };
        return _this;
    }
    UserDropdownMenu.prototype.renderLoggedInMenu = function () {
        var _a = this.props, t = _a.t, className = _a.className, currentUser = _a.currentUser, pointsCount = _a.pointsCount, csrfToken = _a.csrfToken, pushMyGroupsModal = _a.pushMyGroupsModal, verificationEmail = _a.verificationEmail, canEnableMatureContent = _a.canEnableMatureContent, flags = _a.flags;
        var emailVerificationFlowV2 = flags.includes('email_verification_flow_v2');
        var loggedInUser = currentUser;
        return (React.createElement(StandardMenu, { lightText: true, containerId: "site-header-user-menu", containerRole: "dialog", className: classnames(className, s['user-menu'], SiteHeaderStyles['icon-submenu']), itemClassName: s['user-menu-item'], groupClassName: s['user-menu-group'], items: [
                {
                    items: [
                        {
                            label: (React.createElement(Flex, { alignItems: "baseline", justifyContent: "space-between", className: s['user-profile-line'] },
                                React.createElement(UserLink, { className: s['user-link'], symbolClassName: s['user-link-symbol'], user: loggedInUser, withTooltip: false, biData: {
                                        menu_item: 'username',
                                        menu_name: 'profile',
                                        sectionname: 'menu',
                                    } }))),
                        },
                        this.getBuyCore(),
                    ],
                },
                !!verificationEmail &&
                    !emailVerificationFlowV2 && {
                    items: [
                        {
                            label: React.createElement(VerificationReminder, { email: verificationEmail }),
                            className: s['verification-item'],
                        },
                    ],
                    className: s['verification-group'],
                },
                !verificationEmail && {
                    items: [
                        {
                            label: t('siteHeader.myGroups'),
                            onClick: function () {
                                pushMyGroupsModal(t('siteHeader.myGroups'));
                            },
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                                    menu_item: 'myGroups',
                                    menu_name: 'profile',
                                },
                            },
                        },
                        {
                            label: t('siteHeader.myStash'),
                            link: URLS.STASH,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                                    link_url: URLS.STASH,
                                    menu_item: 'stash',
                                    menu_name: 'profile',
                                },
                            },
                        },
                        this.getWixPortfolio(),
                    ],
                },
                !verificationEmail && {
                    items: [
                        {
                            label: (React.createElement("div", { className: s['two-side-label'] },
                                React.createElement("span", null, t('siteHeader.pointsBalance')),
                                pointsCount && (React.createElement("span", null, numeral(pointsCount).format('0,0'))))),
                            link: URLS.POINTS,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                                    link_url: URLS.POINTS,
                                    menu_item: 'points',
                                    menu_name: 'profile',
                                },
                            },
                        },
                        {
                            label: t('siteHeader.myEarnings'),
                            link: URLS.EARNINGS,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                                    link_url: URLS.EARNINGS,
                                    menu_item: 'earnings',
                                    menu_name: 'profile',
                                },
                            },
                        },
                        {
                            label: t('siteHeader.myOrderHistory'),
                            link: URLS.ORDERS,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                                    link_url: URLS.ORDERS,
                                    menu_item: 'order_history',
                                    menu_name: 'profile',
                                },
                            },
                        },
                    ],
                },
                {
                    items: [
                        this.getThemeSwitcherIfApplicable(),
                        {
                            label: t('siteHeader.settings'),
                            link: URLS.SETTINGS,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                                    link_url: URLS.SETTINGS,
                                    menu_item: 'settings',
                                    menu_name: 'profile',
                                },
                            },
                        },
                        canEnableMatureContent && this.getMatureToggleItem(),
                    ],
                    className: verificationEmail && s['post-verification-group'],
                },
                {
                    items: [
                        {
                            label: t('siteHeader.helpAndFAQ'),
                            link: URLS.HELP,
                            target: '_blank',
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                                    link_url: URLS.HELP,
                                    menu_item: 'help_and_faq',
                                    menu_name: 'profile',
                                },
                            },
                        },
                        {
                            label: (React.createElement(LogoutItem, { formRef: this.logoutItemRef, token: csrfToken, label: React.createElement(BiSpan, { biData: {
                                        evid: BiEventType.TOP_NAV_MENU_CLICK,
                                        link_url: URLS.LOGOUT,
                                        menu_item: 'logout',
                                        menu_name: 'profile',
                                    } }, t('siteHeader.logOut')) })),
                            onClick: this.handleLogout,
                        },
                    ],
                },
                {
                    items: [this.getVersionSwitcher()],
                },
            ] }));
    };
    UserDropdownMenu.prototype.renderLoggedOutMenu = function () {
        var _a = this.props, t = _a.t, className = _a.className;
        return (React.createElement(StandardMenu, { lightText: true, containerId: "site-header-user-menu", containerRole: "dialog", className: classnames(className, s['user-menu'], SiteHeaderStyles['icon-submenu']), items: [
                {
                    items: [
                        this.getBuyCore(),
                        this.getThemeSwitcherIfApplicable(),
                        this.getMatureToggleItem(),
                    ],
                },
                {
                    items: [
                        {
                            label: t('siteHeader.helpAndFAQ'),
                            link: URLS.HELP,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                                    link_url: URLS.HELP,
                                    menu_item: 'help_and_faq',
                                    menu_name: 'profile',
                                },
                            },
                        },
                        {
                            label: t('siteHeader.userMenu.termsOfService'),
                            link: URLS.TOS,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                                    link_url: URLS.TOS,
                                    menu_item: 'tos',
                                    menu_name: 'profile',
                                },
                            },
                        },
                        {
                            label: t('siteHeader.userMenu.privacyPolicy'),
                            link: URLS.PRIVACY,
                            componentClass: BiLink,
                            componentProps: {
                                biData: {
                                    evid: BiEventType.TOP_NAV_MENU_CLICK,
                                    link_url: URLS.PRIVACY,
                                    menu_item: 'privacy_policy',
                                    menu_name: 'profile',
                                },
                            },
                        },
                    ],
                },
            ] }));
    };
    UserDropdownMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, t = _a.t, currentUser = _a.currentUser, verificationEmail = _a.verificationEmail, isLoggedIn = _a.isLoggedIn, isOpen = _a.isOpen, innerRef = _a.innerRef, flags = _a.flags;
        var touchIsOpen = this.state.touchIsOpen;
        var userSymbol = currentUser ? currentUser.type : 'regular';
        var avatarClassName = classnames(SiteHeaderStyles['icon-button'], s['avatar'], s[userSymbol]);
        var emailVerificationFlowV2 = flags.includes('email_verification_flow_v2');
        return (React.createElement("div", { className: classnames(s['user-dropdown'], SiteHeaderStyles['icon-button-has-submenu'], (isOpen || touchIsOpen) && SiteHeaderStyles['active'], verificationEmail &&
                !emailVerificationFlowV2 &&
                SiteHeaderStyles['pulsing-animation']), ref: innerRef },
            React.createElement(Button, { view: "b3", className: s['user-menu-button'], "aria-haspopup": true, "aria-expanded": isOpen, "aria-controls": "site-header-user-menu", onClick: this.handleClickUserMenuOpen }, t('siteHeader.userMenu.open')),
            isLoggedIn && (React.createElement(React.Fragment, null,
                React.createElement(UserAvatar, { user: currentUser, size: 30, className: avatarClassName, showSymbol: !verificationEmail, symbolClassName: s['avatar-symbol'], withLink: true, onTouchEnd: function (e) { return _this.handleTouch(e); }, withTooltip: false, biData: { sectionname: 'header' } }),
                this.renderLoggedInMenu())),
            !isLoggedIn && (React.createElement(React.Fragment, null,
                React.createElement(UserAvatarPlaceholder, { className: avatarClassName }),
                this.renderLoggedOutMenu()))));
    };
    return UserDropdownMenu;
}(React.Component));
export { UserDropdownMenu };
export default withTranslation()(withFeatureFlags(onClickOutside(UserDropdownMenu)));
//# sourceMappingURL=UserDropdownMenu.js.map